import NoLongerForSaleSection from './NoLongerForSaleSection.component';

export default NoLongerForSaleSection;
